import { render, staticRenderFns } from "./AccessRequestModal.vue?vue&type=template&id=0600854a"
import script from "./AccessRequestModal.vue?vue&type=script&lang=js"
export * from "./AccessRequestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports